"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classnames_1 = require("classnames");
var utils_1 = require("../utils");
var icon_1 = require("../icon");
exports.default = (function (_a) {
    var theme = _a.theme, className = _a.className, upIconClassName = _a.upIconClassName, downIconClassName = _a.downIconClassName, _b = _a.direction, direction = _b === void 0 ? "up" : _b, _c = _a.size, size = _c === void 0 ? 1.4 : _c;
    var classes = classnames_1.default(theme["trend-arrow"], className, theme[direction]);
    var cssSize = utils_1.toREMString(size);
    var style = {
        width: cssSize,
        height: cssSize
    };
    return (React.createElement("div", { className: classes, style: style },
        React.createElement("div", { className: theme.train },
            React.createElement(icon_1.default, { className: classnames_1.default(theme["up-icon"], upIconClassName), iconName: "icon-increase-small", size: size }),
            React.createElement(icon_1.default, { className: classnames_1.default(theme["down-icon"], downIconClassName), iconName: "icon-decrease-small", size: size }))));
});
